const rankingItems = [
  { rank: 1, title: '狂飙', type: '电视剧', hot: '本周播放量第一', change: 'up' },
  { rank: 2, title: '消失的她', type: '电影', hot: '悬疑榜持续霸榜', change: 'up' },
  { rank: 3, title: '奔跑吧·生态篇', type: '综艺', hot: '新季开播热度飙升', change: 'up' },
  { rank: 4, title: '流浪地球2', type: '电影', hot: '科幻区长期第一', change: 'same' },
  { rank: 5, title: '三体', type: '电视剧', hot: '口碑发酵持续升温', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 text-xs font-medium text-primary-700 bg-primary-50 rounded-full mb-3 whitespace-nowrap">
              热度排行
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
              本周最受观众欢迎的内容排行
            </p>
          </div>

          <div className="max-w-[720px] mx-auto bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 md:p-5 border-b border-background-100 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer"
              >
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm font-bold flex-shrink-0 ${
                  item.rank === 1 ? 'bg-accent-500 text-white' :
                  item.rank === 2 ? 'bg-accent-300 text-accent-900' :
                  item.rank === 3 ? 'bg-accent-200 text-accent-800' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                    <span className="px-2 py-0.5 text-xs rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap">{item.type}</span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.hot}</p>
                </div>
                <div className="flex-shrink-0">
                  {item.change === 'up' ? (
                    <i className="ri-arrow-up-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                  ) : (
                    <i className="ri-subtract-line text-foreground-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}